// extracted by mini-css-extract-plugin
export var root = "uXwz";